/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React from "react";
import PropTypes from "prop-types";
import axios from "axios/dist/axios.min.js";
import parseParams from "../../utils/parseParams";
import moment from 'moment';
import utils from "../../utils/utils";
import px2rem from '../../utils/px2rem';
import "./style.less";

class PipelineSpikeProduct extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      spikeProduct: {},
      countDown: {
        hour: '00',
        minute: '00',
        second: '00',
      },
      show_toast: false,
      toast_text: '',
      toast_sub_text: ''
    };
    this.countDownIntel = '';
    this.remindDisable = false;
    this.toastInterval = null;
    this.app_version = '';
  }

  componentDidMount() {
    this.app_version = utils.getVersion();
    this.getProductData();
    this.focusWebview();
  }
  showView = () => {
    if (utils.isShihuo()) {
      if (!utils.isAndroid() && utils.SHDiffVersion(this.app_version, '7.11.0') && utils.SHDiffVersion('7.20.0', this.app_version)) return false
      return true;
    }
    return true
  }
  componentWillUnmount() {
    clearInterval(this.countDownIntel);
  }

  getProductData() {
    const itemList = this.props.config.itemList;
    const idList = [];
    itemList.forEach(item => {
      if (item.id) {
        idList.push(item.id);
      }
    });

    const params = {
      seckill_ids: idList.join(','),
      user_indentify: "auto"
    }

    const reqUrl = 'https://miaosha.shihuo.cn/app_swoole_seckill_v2/getSeckillByIds';
    axios({
      url: reqUrl,
      method: "get",
      withCredentials: true,
      params: {
        ...params,
        token: utils.parseToken(params),
      },
    }).then((res) => {
      if (res.data.status === 0) {
        const dataList = res.data.data.sec_list || [];
        let spikeProduct = {};
        // 秒杀开始时间大于当前时间三十秒，使用这个商品作为展示
        for (let i = 0; i < dataList.length; i += 1) {
          const nowTime =  moment().unix();
          if (Number(dataList[i].start_time) > nowTime || (Number(dataList[i].start_time) <= nowTime && Number(dataList[i].end_time) >= nowTime)) {
            spikeProduct = dataList[i];
            spikeProduct.start_time = Number(spikeProduct.start_time);
            break;
          }
        }

        if (!spikeProduct.id && dataList.length > 0) {
          // 如果找不到秒杀商品（代表当前组件中所配置的所有秒杀场次均已结束），展示最后一个秒杀场次的信息
          spikeProduct = dataList[dataList.length - 1];
        }    

        this.setState({
          spikeProduct,
        }, () => {
          // 有秒杀商品且开始时间在当天内，开始倒计时
          if (spikeProduct && moment(moment.unix(Number(spikeProduct.start_time))).isSame(moment(), 'day') && Number(spikeProduct.start_time >= moment().unix())) {
            this.setTimeCountDown();
          }
        });
      }
    });
  }

  // 订阅秒杀
  onRemind = (seckill_id) => {
    if (this.remindDisable) {
      return;
    }
    this.remindDisable = true;
    axios({
      url: 'https://miaosha.shihuo.cn/app_swoole_seckill_v2/subMsg',
      method: 'post',
      withCredentials: true,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: parseParams({
        seckill_id
      }),
    }).then(res => {
      const { status, msg } = res.data;
      if (status == 0) {
        this.setState({
          show_toast: true,
          toast_text: "订阅成功",
          toast_sub_text: ""
        });
        this.getProductData();  // 订阅成功后，刷新秒杀信息
      } else {
        this.setState({
          show_toast: true,
          toast_text: msg,
          toast_sub_text: ""
        });
      }
      setTimeout(() => {
        this.remindDisable = false;
      }, 1000);
    })
  }

  // 点击秒杀按钮
  handleSeckillBtn = (item) => {
    utils.uploadTrack(this.props);
    /**
     * 秒杀状态 status:
        1 未开始
        2 进行中
        3 已抢光
        4 已结束
     */
    if (item.status === 1) {
      if (item.subscription === 0) {
        // 未订阅
        !this.remindDisable && this.onRemind(item.id)
      } else {
        // 已订阅
        this.productClick(item);
      }
    } else {
      this.productClick(item);
    }
  }

  productClick = (item) => {
    // 秒杀商品跳转
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.url,
        props: this.props,
      })
      return
    }

    const options = {};
    utils.jumpToUrl(this.props.routeParams, item.url, item.url, options, -1, this.props);
  }

  setTimeCountDown = () => {
    // 设置倒计时
    const self = this;
    const spikeProduct = this.state.spikeProduct || {};
    
    let distanceSecond = Number(spikeProduct.start_time) - moment().unix();

    countDownCalculate.apply(this);
    clearInterval(this.countDownIntel);
    this.countDownIntel = setInterval(countDownCalculate.bind(this), 1000);

    // 倒计时的计算
    function countDownCalculate(){
      if (distanceSecond <= 0) {
        // 清除时间循环，重新开始请求商品数据计算
        clearInterval(this.countDownIntel);
        this.getProductData();
        return;
      }

      distanceSecond -= 1;
      // 计算倒计时时分秒
      const hour = parseInt(distanceSecond / 3600, 10);
      const lastSeconds = distanceSecond % 3600; // 除过小时之后剩余时间
      const minute = parseInt(lastSeconds / 60, 10);
      const second = distanceSecond % 60;

      const countDown = {
        hour: hour < 10 ? `0${hour}` : hour,
        minute: minute < 10 ? `0${minute}` : minute,
        second: second < 10 ? `0${second}` : second,
      };
      self.setState({
        countDown,
      })
    }
  }

  renderToast = () => {
    const { show_toast, toast_text, toast_sub_text } = this.state;
    if (show_toast) {
      if (!this.toastInterval) {
        this.toastInterval = setTimeout(() => {
          this.setState({
            show_toast: false,
            toast_text: ''
          });
          this.toastInterval && clearTimeout(this.toastInterval);
          this.toastInterval = null;
        }, 2500); 
      }
      return (
        <div
          className="toast"
          style={{
            padding: `${px2rem('6px')} ${px2rem('12px')}`,
            borderRadius: px2rem('4px'),
            fontSize: px2rem('16px')
          }}>
          <p>{toast_text}</p>
          <p>{toast_sub_text}</p>
        </div>
      )
    } else {
      return null;
    }
  }

  renderBtnText = (item) => {
    const { subscription, status } = item;
    if (status === 1) {
      if (subscription === 0) {
        return '预约秒杀'
      } else {
        return '已预约'
      }
    } else {
      return '去秒杀'
    }
  }

  render() {
    
    const { baseConfig } = this.props.config;
    const spikeProduct = this.state.spikeProduct;
    if (!spikeProduct.id) {
      return null;
    }
    if (!this.showView() && spikeProduct.pd_type == 4) {
      return null;
    }
    let spikeTimeSlogan = '';
    if (moment(moment.unix(Number(spikeProduct.start_time))).isSame(moment(), 'day')) {
      // 使用倒计时
      const countDown = this.state.countDown;
      spikeTimeSlogan = `${countDown.hour}:${countDown.minute}:${countDown.second} 后秒杀开始`;
    } else {
      // 设置秒杀日期文案
      const startTime = moment.unix(Number(spikeProduct.start_time));
      const month = (startTime.get('month') + 1) < 10 ? `0${startTime.get('month') + 1}` : startTime.get('month') + 1;
      const date = startTime.get('date') < 10 ? `0${startTime.get('date')}` : startTime.get('date');
      const hour = startTime.get('hour') < 10 ? `0${startTime.get('hour')}` : startTime.get('hour');
      const minutes = startTime.get('minute') < 10 ? `0${startTime.get('minute')}` : startTime.get('minute');
      spikeTimeSlogan = `${month}月${date}日 ${hour}:${minutes} 开启`;
    }

    return (
      <div
        className="pipeline-spike-product"
        {...this.props['customAttributes']}
        style={{
          paddingTop: baseConfig.moduleMarginTop >= 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginTop: baseConfig.moduleMarginTop < 0 ? `${baseConfig.moduleMarginTop}px` : 0,
        }}
      >
        <div
          className="spike-wrapper"
          style={{
            padding: `${px2rem('8px')} ${px2rem('25px')} ${px2rem('8px')} ${px2rem('14px')}`,
            backgroundImage: `url('${utils.formatImgUrl(baseConfig.bgImg, this.props.webpSupport)}')`,
          }}>
            {
              spikeProduct.pic_1 && <img
                className="product-img"
                src={utils.formatImgUrl(spikeProduct.pic_1, this.props.webpSupport)}
                alt="商品图"
                style={{
                  width: px2rem('71px'),
                  height: px2rem('71px'),
                  marginRight: px2rem('4px'),
                  borderRadius: px2rem('6px')
                }}
              />
            }
            <div className="detail-info" style={{paddingTop: spikeProduct.status === 1 ? px2rem('5px') : px2rem('8px')}}>
              {
                (spikeProduct.status === 1 || spikeProduct.status === 4) 
                  && (
                    <div
                      className="spike-time"
                      style={{
                        fontSize: px2rem('12px'),
                        color: baseConfig.timeTextColor
                      }}
                    >
                      {spikeProduct.status === 1 ? spikeTimeSlogan : '活动已结束'}
                    </div>
                  )
              }
              <div
                className="product-name"
                style={{
                  width: px2rem('150px'),
                  marginTop: px2rem('4px'),
                  marginBottom: spikeProduct.status === 1 ? px2rem('-3px') : px2rem('6px'),
                  fontSize: px2rem('13px'),
                }}>
                  {spikeProduct.title}
                </div>
              <div className="price-bar">
                <div className="price-content">
                  <div className="price" style={{fontSize:px2rem('1px')}}>
                    <img 
                      src={baseConfig.spikePriceIcon || 'https://static.shihuocdn.cn/admin/files/20220210/85d4dc36fbcff9aacd98f392e4bb3d3d.png'}
                      alt=""
                      className="price-icon"
                      style={{
                        width: px2rem('34px'),
                        height: px2rem('13px'),
                        marginRight: px2rem('2px'),
                        marginBottom: px2rem('-1px')
                      }}
                    />
                    <span className="symbol" style={{ fontSize: px2rem('14px'),  marginLeft: px2rem('2px'), marginRight: px2rem('1px')}}>¥</span>
                    <span style={{display:'inline-block',fontSize:px2rem('20px')}}>
                      {parseFloat(spikeProduct.price)}
                    </span>
                  </div>
                  <div className="origin-price" style={{ fontSize: px2rem('11px'), marginBottom: px2rem('-4px') }}>
                    原价&yen;{parseFloat(spikeProduct.original_price)}
                  </div>
                </div>
                <div
                  className="spike-btn"
                  style={{
                    width: px2rem('80px'),
                    height: px2rem('29px'),
                    backgroundSize: "100% 100%",
                    backgroundImage: `url(${utils.formatImgUrl(baseConfig.spikeIcon, this.props.webpSupport)})`,
                    fontSize: px2rem('15px'),
                    marginBottom: px2rem('-2px')
                  }}
                  onClick={this.handleSeckillBtn.bind(this, spikeProduct)}
                >
                  {this.renderBtnText(spikeProduct)}
                </div>
              </div>
            </div>
        </div>
        {this.renderToast()}
      </div>
    );
  }

  focusWebview() {
    if (utils.isAndroid()) {
      window.Jockey.on("focus:webview", () => {
        // 刷新秒杀状态
        this.getProductData();
      });
    } else {
      document.addEventListener(
        "visibilitychange",
        () => {
          if (document.hidden) {
            return;
          } else {
            // 刷新秒杀状态
            this.getProductData();
            return;
          }
        },
        false
      );
    }
  }

}

PipelineSpikeProduct.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineSpikeProduct };
export default PipelineSpikeProduct;



// WEBPACK FOOTER //
// ./components/pipeline-spikeProduct/index.js